export const GAODE_KEY = 'f6b999ade5782b9d8e2e3c4a7569bdfa'
export const TDT_KEY = '34c1f2065f45b8cfe4f711324200066e'
export const CESIUM_ION_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI2ZTEzMzk0YS00MmFkLTQyMjYtOTA1Zi1iYzA4ZGNjM2U4ZDAiLCJpZCI6MTY3MTE2LCJpYXQiOjE2OTUwNDIzNTN9.3Th3o3URY7juTTczl7SJ0OS9DTSbEOwrjSf9aET4760'

export interface layerConfig {
  key: string
  label?: string
  show?: boolean // 默认关闭
  type?: 'group' | 'leaf' // 默认leaf
}
/**默认开启的图层 */
export const layersTreeConfig: layerConfig[] = [
  { key: 'camera', show: true, label: '摄像头' },
  // { key: 'efence', show: false, label: '电子围栏' },
  // { key: 'dynamicShip', show: false, label: '动态船只' },
  // { key: 'equip', show: false, label: '设备' },
  { key: 'bouy', show: true, label: '航标(矢量)' },
  //{ key: 'bouy2', show: false, label: '航标(卫星)' },
  // { key: 'wmsDw', show: false, label: '水深点' },
  // { key: 'fzubouy', show: false, label: '航标' },
  // { key: 'dwrt', show: false, label: '航道' },
  { key: 'depthArea', show: true, label: '水深' },
  { key: 'ship66', show: false, label: '船只' },
  { key: 'dwrtshp', show: true, label: '航道(矢量)' },
  { key: 'Secondarywater', show: true, label: '危险水域' },
  { key: 'bridge', show: true, label: '桥梁' },
  { key: 'aidStation', show: true, label: '搜救站' },
  { key: 'dock', show: true, label: '码头' },
  { key: 'gasStation', show: true, label: '加油站' },
  { key: 'sandbarLayer', show: true, label: '沙洲' },
  { key: 'AISVHFLayer', show: true, label: '基站' },
]
